import generatedBrandColors from '@baserow/modules/core/utils/generatedBrandColors.json'

/**
 * Stock palette of base colors for the "Icon and color" modal. Mirrors
 * `APPLICATION_BASE_COLORS` on the backend (`baserow.core.models`).
 *
 * Twenty base colors in two rows of ten: a light row and a dark row of the same
 * ten hues — same hue families as the select/grid tag palette, so a base color
 * reads as "the same blue/green/..." as its tags. The base header flips its
 * label between black/white via `readableTextColor`, so the light row gets black
 * text/icon and the dark row gets white automatically.
 *
 * Order matters: the picker fills ten per row, so the first ten (light) form the
 * top row and the last ten (dark) the bottom row.
 */
const STOCK_APPLICATION_BASE_COLORS = [
  // Light row
  '#93C5FD', // light blue
  '#67E8F9', // light cyan
  '#86EFAC', // light green
  '#BEF264', // light lime
  '#FDE047', // light yellow
  '#FDBA74', // light orange
  '#FCA5A5', // light red
  '#F9A8D4', // light pink
  '#C4B5FD', // light purple
  '#CBD5E1', // light gray
  // Dark row
  '#2563EB', // blue
  '#0891B2', // cyan
  '#16A34A', // green
  '#65A30D', // lime
  '#CA8A04', // yellow
  '#EA580C', // orange
  '#DC2626', // red
  '#DB2777', // pink
  '#7C3AED', // purple
  '#475569', // gray
]

// White-label override: when a repo-root brand.json defines `hues`, the build
// writes them into generatedBrandColors.json (see build/brand/generate.mjs) and
// the picker shows the brand colors instead of the stock palette.
export const APPLICATION_BASE_COLORS =
  Array.isArray(generatedBrandColors.baseColors) &&
  generatedBrandColors.baseColors.length > 0
    ? generatedBrandColors.baseColors
    : STOCK_APPLICATION_BASE_COLORS

// Default to a saturated tone rather than a pale tint.
export const DEFAULT_APPLICATION_COLOR = APPLICATION_BASE_COLORS.includes(
  '#2563EB'
)
  ? '#2563EB'
  : APPLICATION_BASE_COLORS[APPLICATION_BASE_COLORS.length - 1]
